import React, {useState} from 'react';
import {useSessionService} from "../../../../../../../services/Session/sessionService";
import {useTranslation, withTranslation} from "react-i18next";
import {ReactComponent as PlusIco} from "../../../../../../../../images/icons/plus.svg";
import {ReactComponent as EditIco} from "../../../../../../../../images/icons/edit.svg";
import {ReactComponent as LocationIco} from "../../../../../../../../images/icons/location.svg";
import {RootState} from "../../../../../../../../reducers";
import {getSession} from "../../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {api} from "../../../../../../../services/Api/api";
import {useGeolocation} from "../../../../../../../hooks/useGeolocation";

interface OwnProps {
    session: Record<string, any>;
    setShowAddressModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreMapPageNavbarButtons = ({session, setShowAddressModal}: Props) => {
    const [loadingGeolocation, setLoadingGeolocation] = useState(false);
    const sessionService = useSessionService();
    const {t} = useTranslation();
    const {getPosition, handleGeolocationError} = useGeolocation();

    const handleGeolocation = async () => {
        try {
            setLoadingGeolocation(true);
            const position = await getPosition();
            const {latitude, longitude} = position.coords;
            const res = await api.getAddressByCoordinates({latitude, longitude});
            await sessionService.update({
                ...session,
                address: {
                    street: res.street ?? "",
                    city: res.city ?? "",
                    country: res.country ?? "",
                    zip_code: res.zip_code ?? "",
                    flat_nr: res.flat_nr ?? "",
                    build_nr: res.build_nr ?? "",
                }
            });
            await sessionService.updateCoordinates({
                latitude,
                longitude
            });
        } catch (error) {
            handleGeolocationError(error as GeolocationPositionError);
        } finally {
            setLoadingGeolocation(false);
        }
    }

    return (
        <>
            <button className="btn btn-icon" onClick={() => setShowAddressModal(true)}
                    aria-label={
                        session.full_address ?
                            t("modules.multistore.action.edit_address.title") :
                            t("modules.multistore.action.set_address.title")
                    }
            >
                {session.full_address ? <EditIco aria-hidden="true"/> : <PlusIco aria-hidden="true"/>}
            </button>
            <button className={`btn btn-icon btn-spinner ${loadingGeolocation ? "loading" : ""}`}
                    onClick={handleGeolocation}
                    aria-label={t("modules.multistore.field.geolocation.title")}>
                {!loadingGeolocation && <LocationIco aria-hidden="true"/>}
                <span className="left spinner-border spinner-border-sm"/>
            </button>
        </>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreMapPageNavbarButtons));